import React, { Component } from 'react';

import { Link } from '../common';

type State = {
  isOpen: boolean,
};

class InfoTooltip extends Component<{}, State> {
  constructor() {
    super();

    this.tooltipRef = React.createRef();
    this.state = {
      isOpen: false,
    };
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.closeTooltip, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.closeTooltip, false);
  }

  toggleTooltip = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  closeTooltip = (element: Object) => {
    if (
      this.tooltipRef &&
      this.tooltipRef.contains &&
      !this.tooltipRef.contains(element.target)
    ) {
      this.toggleTooltip();
    }
  };

  setTooltipRef = (element: Object) => {
    this.tooltipRef = element;
  };

  render() {
    const { isOpen } = this.state;

    return (
      <>
        <button
          type="button"
          name="ereceipt-tooltip"
          data-automation-id="ereceipt-tooltip"
          className="hide--xs show alert u__text--alternate u--paddingNone"
          onClick={this.toggleTooltip}
        >
          <span className="mw-icon-info" />
        </button>
        {isOpen && (
          <div
            ref={this.setTooltipRef}
            className="hdReactTooltip hdReactTooltip--info"
          >
            <p data-automation-id="ereceipt-summary-payment-cards-tooltip">
              {`You can view e-receipts here when you make In-Store purchases with
              a `}
              <Link
                data-automation-id="payment-cards-link"
                content="credit card"
                href="/account/view/paymentcards"
              />
              {` that you have saved in your account.`}
            </p>
          </div>
        )}
      </>
    );
  }
}

export default InfoTooltip;
